import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(requestBody: Request): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/ApiKey/Generate`;
	return axios.post(url, requestBody).toOptionalMapped((x) => x.data);
}

export interface Request {
	displayName: string;
	expirationTime: string | null;
}

export interface Response {
	data: ResponseData;
}

export interface ResponseData {
	id: string;
	displayName: string;
	key: string;
	expirationTime: string | null;
}
